




































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import CandidatePortalLogo from "./CandidatePortalLogo.vue";
import { vxm } from "./../store.vuex";
import router from "../router";
import { RecruiterRequest } from "../models/referrals/recruiterrequest";

@Component({
  name: "DashBanner",
  components: {
    CandidatePortalLogo
  }
})
export default class DashBanner extends Vue {
  private recruiterRequest: RecruiterRequest = new RecruiterRequest();

  closeMenu() {
    const elem = document.getElementById("navbarNav");
    if (elem) {
      elem.classList.remove("show");
    }
  }

  get isLoggedIn() {
    console.log("user is logged in ....", vxm.users.isLoggedIn);
    return vxm.users.isLoggedIn;
  }

  logout() {
    console.log("user has logged off ....");
    vxm.users.logout();
    console.log(vxm.users.isLoggedIn);
    this.$router.push("/");
  }
}
